import React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

@inject('AuthStore')
@observer
export default class AuthButton extends React.Component {
  render(){
    return ( this.props.AuthStore.isAuthenticated ? (
      <Link data-cy="signout" to="/signout">Sair</Link>
    ) : (
      <Link to="/signin">Entrar</Link>
    ))
  }
}
